import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    const clone = this.templateTarget.content.cloneNode(true)
    const id = new Date().getTime()
    clone.querySelectorAll("input, textarea").forEach((el) => {
      if (el.name) el.name = el.name.replace("NEW_RECORD_ID", id)
    })
    this.containerTarget.appendChild(clone)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-nested-links-target='linkRow']")
    if (row) {
      const destroyInput = row.querySelector("input[name*='[_destroy]']")
      if (destroyInput) {
        destroyInput.value = "1"
        row.style.display = "none"
      } else {
        row.remove()
      }
    }
  }
}
